import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from 'services/firebase';
import { login as firebaseLogin, register, logOut } from 'services/auth';

// Create context
export const AuthContext = createContext();

// Provider
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Listen to Firebase for user state changes
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      setUser(firebaseUser); // null if logged out
    });
    return unsubscribe;
  }, []);

  // Connect context methods to Firebase
  const login = async (email, password) => {
    const userCredential = await firebaseLogin(email, password);
    return userCredential;
  };
  const registerUser = (email, password) => register(email, password);
  const logout = () => {
    logOut();
  };

  const refreshUser = async () => {
    const currentUser = auth.currentUser;
    if (currentUser) {
      await currentUser.reload();
      // refresh token with new claims
      await currentUser.getIdToken(true);
      setUser(currentUser);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, registerUser, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

// Hook
export const useAuth = () => useContext(AuthContext);
